import { useCallback, useMemo, useState } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { getCurrentSendedLeg } from '../../selectors/sended-data';
import { validateState } from '../hooks/useForm/validate';
import { useSingleConvert } from '../hooks/useMeasureConverter';
import { useValidateState } from '../hooks/useValidateState';

export const useRefueling = () => {
    const decisionFuel = useSelector((state) => {
        const currentLeg = getCurrentSendedLeg(state);
        const takeOff = get(currentLeg, 'takeOff', {});

        return takeOff.decisionFuel;
    }, shallowEqual);
    const { t: translate } = useTranslation();

    const [refueling, setRefueling] = useState(decisionFuel);
    const max = useSingleConvert()(296000);
    const fuelFieldValidator = useMemo(() => ({ type: 'decimal', min: 0, max, precision: [7, 1] }), [max]);
    const [errorText, changeError] = useValidateState(fuelFieldValidator, refueling, true, translate);

    const handleRefuelingChange = useCallback(
        (event) => {
            const validateRes = validateState(fuelFieldValidator, event.target.value, true, translate);
            setRefueling(event.target.value);
            changeError(validateRes ? validateRes.errorText : '');
        },
        [validateState, changeError, setRefueling, fuelFieldValidator, translate]
    );

    const handleInputFocus = useCallback(() => {
        if (errorText) {
            changeError('');
        }
    }, [errorText]);

    return {
        refueling,
        errorText,
        handleRefuelingChange,
        handleInputFocus,
    };
};
